<template>
  <div class="view">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'staffRequirementSubmission', params: {} }"
      >
        All Staff Submissions
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider v-if="staffRequirementSubmission.staffId">/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        v-if="staffRequirementSubmission.staffId"
        :exact="true"
        :to="{ name: 'staffView', params: { id: staffRequirementSubmission.staffId } }"
      >
        {{ staffRequirementSubmission.staffName }}
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :to="{ name: 'staffRequirementSubmissionView', params: {} }"
      >
        Staff Submission
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card v-if="loaded">
      <v-card-title> Staff Submission </v-card-title>
      <v-card-text>
        <v-alert dense type="warning" v-if="staffRequirementSubmission.state == 'pending' && staffRequirementSubmission.formSubmissionId">
          This online submission is pending review
        </v-alert>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-if="staffRequirementSubmission.staffId">
                <td max-width="35%" class="text-subtitle-1">Staff:</td>
                <td>
                  <router-link :to="{name: 'staffView', params: {id: staffRequirementSubmission.staffId }}">
                    {{ staffRequirementSubmission.staffName }}
                  </router-link>
                </td>
              </tr>

              <tr>
                <td max-width="35%" class="text-subtitle-1">Submission:</td>
                <td>
                  <div v-if="staffRequirementSubmission.createdByName">
                    By {{ staffRequirementSubmission.createdByName }} on
                    {{ staffRequirementSubmission.createdAt | formatDateYear }}
                    <span v-if="staffRequirementSubmission.submissionMethod"
                      >via
                      {{ staffRequirementSubmission.submissionMethod }}</span
                    >
                  </div>
                  <div class="my-2" v-if="staffRequirementSubmission.approvedBy">
                    Approved by {{ staffRequirementSubmission.approvedByName }} on
                    {{ staffRequirementSubmission.approvedOn | formatDateYear }}
                  </div>
                </td>
              </tr>

              <tr v-if="staffRequirementSubmission.notes">
                <td max-width="35%" class="text-subtitle-1">Notes:</td>
                <td>{{ staffRequirementSubmission.notes }}</td>
              </tr>

              <tr v-if="staffRequirementSubmission.formSubmissionId">
                <td max-width="35%" class="text-subtitle-1">
                  Online Form Submission:
                </td>
                <td>
                  <div class="d-flex  justify-space-between">
                    <form-response
                      class="my-auto"
                      :responseId="staffRequirementSubmission.formSubmissionId"
                    />

                    <v-btn @click="approvePending" text class="my-2" v-if="staffRequirementSubmission.state == 'pending'">Approve</v-btn>
                  </div>
                </td>
              </tr>

              <tr v-if="staffRequirementSubmission.requirements">
                <td max-width="35%" class="text-subtitle-1">Requirements:</td>
                <td>
                  <div class="my-2">
                    <div
                      class="
                        my-1
                        d-flex
                        justify-space-between
                        flex-column flex-md-row
                      "
                      v-for="(
                        requirement, index
                      ) in requirementsSorted"
                      :key="`${requirement.requirementId}-${requirement.forDoseNumber}`"
                    >
                      <span
                        ><span
                          v-if="
                            staffRequirementSubmission.requirements.length > 1
                          "
                          >{{ index + 1 }}.</span
                        >
                        {{ requirement.requirementName }}</span
                      >
                      <span
                        class="ml-4 font-weight-light"
                        v-if="
                          requirement.cerfIssueDate &&
                          requirement.cerfExpireDate
                        "
                      >
                        {{ requirement.cerfIssueDate | formatDateYear }} -
                        {{ requirement.cerfExpireDate | formatDateYear }}
                      </span>
                      <span
                        class="ml-4 font-weight-light"
                        v-if="
                          requirement.type == 'Vaccination' &&
                          requirement.forDoseNumber
                        "
                      >
                        Dose {{ requirement.forDoseNumber }} on
                        {{ requirement.vaccinationDate | formatDateYear }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <attachments-view v-model="staffRequirementSubmission.attachments" />
      </v-card-text>
    </v-card>

    <div class="d-flex justify-space-between ma-5">
      <v-btn @click="goBack">Back</v-btn>
      <v-btn @click="edit(id)" color="primary">Edit</v-btn>
      <v-btn @click="remove(id)" color="warning">Delete</v-btn>
    </div>

    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getStaffRequirementSubmission } from "@/services/staffRequirementSubmission";
const AttachmentsView = () => import("@/components/common/AttachmentsView.vue");
const FormResponse = () => import("@/components/forms/FormResponse.vue");
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");

export default {
  components: { AttachmentsView, FormResponse, ConfirmationDialog },
  data() {
    return {
      id: "",
      staffRequirementSubmission: {},
      loaded: false,
      relations: {},
    };
  },
  computed: {
    requirementsSorted(){
      if(this.staffRequirementSubmission && this.staffRequirementSubmission.requirements){
        const requirements = this.staffRequirementSubmission.requirements;
        requirements.sort((a, b) => a.requirementName.localeCompare(b.requirementName));
        return requirements;
      }
      else{ return [] }
    }
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    ...mapActions("staffRequirementSubmission", [
      "deleteStaffRequirementSubmission",
    ]),
    goBack() {
      this.$router.go(-1);
    },
    edit(id) {
      this.$router.push({
        name: "staffRequirementSubmissionEdit",
        params: { id: id },
      });
    },
    setInstance() {
      getStaffRequirementSubmission(this.id)
        .then((response) => {
          this.staffRequirementSubmission = response.data;
          if (this.staffRequirementSubmission.attachments) {
            this.staffRequirementSubmission.attachments.forEach((file) => {
              const path = `${process.env.VUE_APP_BASE_URL}/compliance/submission/attachment/${file.id}`;
              file.path = path;
            });
          }

          this.loaded = true;
        })
        .catch(() => {
          this.addErrorMessage("Error loading staff submission");
          this.loaded = true;
        });
    },
    getRelationText(id, relationProperty, relationAttribute) {
      const relationList = this.relations[relationProperty];
      if (relationList) {
        const relationObj = relationList.find((r) => r.id == id);
        return relationObj[relationAttribute];
      } else {
        return "";
      }
    },
    approvePending(){
      this.$axios.put('/staffRequirementSubmission/approve-pending/'+this.staffRequirementSubmission.id)
        .then((response) => {
          const approved = response.data;
          this.staffRequirementSubmission.state = approved.state;
          this.staffRequirementSubmission.approvedBy = approved.approvedBy;
          this.staffRequirementSubmission.approvedOn = approved.approvedOn;
        })
    },
    async remove(id) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this submission?"
      );
      if (confirm) {
        this.deleteStaffRequirementSubmission(id)
          .then(() => {
            this.addSuccessMessage(
              "submission was deleted with successfully"
            );
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.setInstance();
    this.$emit("showParent", false);
  },
};
</script>
